<template>
<div class="chapter">
<div class="inner_page">
<h2 style="font-family: Calisto MT;">A Year in the Life of Rebecca Saunders</h2>
<ul style="font-family: Calisto Mt; margin-left: -10px; margin-top: 20px; font-weight: normal !important;">
<li><a href="#/index_split_000#toc_id_1">About the Author</a></li>
<li><a href="#/index_split_001#toc_id_2">Dedication</a></li>
<li><a href="#/index_split_001#toc_id_3">Copyright Information ©</a></li>
<li><a href="#/index_split_003#toc_id_4">Acknowledgements</a></li>
<li><a href="#/index_split_005#toc_id_5">Prologue</a></li>
<li><a href="#/index_split_006#toc_id_6">January</a></li>
<li><a href="#/index_split_007#toc_id_7">February</a></li>
<li><a href="#/index_split_008#toc_id_8">March</a></li>
<li><a href="#/index_split_009#toc_id_9">April</a></li>
<li><span href="#/index_split_010#toc_id_10" title="Link target outside of Sample">May</span></li>
<li><span href="#/index_split_011#toc_id_11" title="Link target outside of Sample">June</span></li>
<li><span href="#/index_split_012#toc_id_12" title="Link target outside of Sample">July</span></li>
<li><span href="#/index_split_013#toc_id_13" title="Link target outside of Sample">August</span></li>
<li><span href="#/index_split_014#toc_id_14" title="Link target outside of Sample">September</span></li>
<li><span href="#/index_split_015#toc_id_15" title="Link target outside of Sample">October</span></li>
<li><span href="#/index_split_016#toc_id_16" title="Link target outside of Sample">November</span></li>
<li><span href="#/index_split_017#toc_id_17" title="Link target outside of Sample">December</span></li>
<li><span href="#/index_split_018#toc_id_18" title="Link target outside of Sample">2nd December, Saturday</span></li>
<li><span href="#/index_split_019#toc_id_19" title="Link target outside of Sample">4 December, Monday</span></li>
<li><span href="#/index_split_020#toc_id_20" title="Link target outside of Sample">8 December, Friday</span></li>
<li><span href="#/index_split_021#toc_id_21" title="Link target outside of Sample">9 December, Saturday</span></li>
<li><span href="#/index_split_022#toc_id_22" title="Link target outside of Sample">11 December, Monday</span></li>
<li><span href="#/index_split_023#toc_id_23" title="Link target outside of Sample">13-21 December</span></li>
<li><span href="#/index_split_024#toc_id_24" title="Link target outside of Sample">23 December, Friday</span></li>
<li><span href="#/index_split_025#toc_id_25" title="Link target outside of Sample">24 December, Saturday</span></li>
<li><span href="#/index_split_026#toc_id_26" title="Link target outside of Sample">Epilogue</span></li>
<li><span href="#/index_split_027#toc_id_27" title="Link target outside of Sample">The Characters</span></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?d12de070